module.exports = __webpack_public_path__ + "static/img/claim-img.b057886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-img.png
// module id = 2xtp
// module chunks = 1